import { useMemo } from "react";
import { PaginationDots, SPACING_WIDE } from "./PaginationDots";

/**
 * BigPerformerPaginationIndicator - Pagination Indicator for Big Performer Banner
 */
export const BigPerformerPaginationIndicator = ({
  items,
  activeId,
  onSlideChange,
  color = "white",
  spacing = SPACING_WIDE,
}) => {
  const pages = useMemo(
    () =>
      items.map((category, index) => {
        const { categoryId, categoryName } = category;
        return {
          id: categoryId,
          ariaLabel: `${index} - ${categoryName}`,
          onClick: (e) => {
            e.preventDefault();
            e.stopPropagation();
            onSlideChange(category, index);
          },
        };
      }),
    [items, onSlideChange],
  );
  return <PaginationDots currentPageId={activeId} pages={pages} color={color} spacing={spacing} />;
};
